
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';

import {ProfileService} from './profile.service';
import {Profile} from './profile.model';

@Injectable()
export class ProfileResolver implements Resolve<Profile> {

  constructor(private profileService: ProfileService) {
  }

  resolve(route: ActivatedRouteSnapshot,
          state: RouterStateSnapshot): Observable<Profile> | Promise<Profile> | Profile {
    return this.profileService.getProfile();
  }

}



// WEBPACK FOOTER //
// ./src/app/profile/profile-resolver.service.ts